import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import cn from 'classnames';
import * as styles from '../../shared_desktop_styles.css';
import { MenuContainer } from '../../../../containers/MenuContainer';
import { AddressInput } from '../../../AddressInput';
import { RoomsCountSelector } from '../../../RoomsCountSelector';
import { AreaInput } from '../../../AreaInput';
import { FilterWithDropdownList } from '../../../packages/FilterWithDropdownList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FlatDesktop = function FlatDesktop(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx(MenuContainer, {}), /*#__PURE__*/_jsx("form", {
      className: styles['form'],
      onSubmit: function onSubmit(e) {
        return e.preventDefault();
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: styles['filters'],
        children: [/*#__PURE__*/_jsx("div", {
          className: cn(styles['filter'], styles['filter-estimation-target']),
          children: /*#__PURE__*/_jsx(FilterWithDropdownList, _objectSpread(_objectSpread({
            className: styles['filter-height']
          }, props.estimationTargetProps), {}, {
            isFirstFilter: true,
            testId: "estimation_target"
          }))
        }), /*#__PURE__*/_jsx("div", {
          className: cn(styles['filter'], styles['filter-address']),
          children: /*#__PURE__*/_jsx(AddressInput, _objectSpread({
            className: styles['filter-height']
          }, props.addressProps))
        }), /*#__PURE__*/_jsx("div", {
          className: styles['filter'],
          children: /*#__PURE__*/_jsx(RoomsCountSelector, _objectSpread({
            className: styles['filter-height']
          }, props.roomsCountSelectorProps))
        }), /*#__PURE__*/_jsx("div", {
          className: styles['filter'],
          children: /*#__PURE__*/_jsx(AreaInput, _objectSpread(_objectSpread({
            className: styles['filter-height']
          }, props.areaProps), {}, {
            isLastFilter: true
          }))
        })]
      })
    })]
  });
};
FlatDesktop.displayName = 'FlatDesktop';